import React from 'react'
import { AuslastungRow } from '@myapp/contract'
import { DataTable, Pagination, TableColumn } from '../../../../shared/ui'

function fmtNum(n: number): string {
  return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function auslastungClass(pct: number | null): string {
  if (pct == null) return ''
  if (pct > 100) return 'text-red-600 font-medium'
  if (pct < 70) return 'text-orange-500 font-medium'
  return 'text-green-600 font-medium'
}

const COLUMNS: TableColumn<AuslastungRow>[] = [
  {
    key: 'technician',
    header: 'Handwerker',
    render: (r) => <span className="font-medium text-[#004494]">{r.technicianName}</span>,
  },
  {
    key: 'sollStd',
    header: 'Soll-Stunden',
    headerClassName: 'min-w-[120px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) => fmtNum(r.sollStd),
  },
  {
    key: 'reparaturzeiten',
    header: 'Reparaturzeiten',
    headerClassName: 'min-w-[130px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) => fmtNum(r.reparaturzeitenStd),
  },
  {
    key: 'nichtReparaturzeiten',
    header: 'Aufgaben',
    headerClassName: 'min-w-[160px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) => fmtNum(r.nichtReparaturzeitenStd),
  },
  {
    key: 'istStd',
    header: 'Ist-Stunden',
    headerClassName: 'min-w-[120px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) => fmtNum(r.istStd),
  },
  {
    key: 'abwesenheiten',
    header: 'Zeitmanagement',
    headerClassName: 'min-w-[120px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) => fmtNum(r.abwesenheitenStd),
  },
  {
    key: 'auslastung',
    header: 'Auslastung',
    headerClassName: 'min-w-[100px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) =>
      r.auslastungPct != null ? (
        <span className={auslastungClass(r.auslastungPct)}>
          {r.auslastungPct.toLocaleString('de-DE', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })}{' '}
          %
        </span>
      ) : (
        <span className="text-gray-400">–</span>
      ),
  },
]

interface AuslastungstabelleListProps {
  items: AuslastungRow[]
  meta: { page: number; limit: number; total: number } | undefined
  isLoading?: boolean
  isFetching?: boolean
  page: number
  onPageChange: (p: number) => void
}

export const AuslastungstabelleList: React.FC<AuslastungstabelleListProps> = ({
  items,
  meta,
  isLoading,
  isFetching,
  page,
  onPageChange,
}) => {
  const totalPages = meta ? Math.ceil(meta.total / meta.limit) : 0
  return (
    <div className="flex flex-col">
      <DataTable<AuslastungRow>
        columns={COLUMNS}
        rows={items}
        getRowKey={(r) => String(r.technicianId)}
        isLoading={isLoading}
        isFetching={isFetching}
        emptyMessage="Keine Daten"
        compact
        minWidth={800}
      />
      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
        isFetching={isFetching}
        disabled={isLoading}
      />
    </div>
  )
}
